jPar.util = jPar.util || {};
deepMerge(true, jPar.util, {
	timezone: {
		setTimezone: function () {
			const _this = this;
			const hasNoFreshTimezoneForSession = jPar.app.appState.get('sessionStorage', 'webapp', 'hasFreshTimezoneForSession') === null;
			const hasNoTimezoneCookie = jPar.util.getCookie('timezone') === null;

			if (hasNoFreshTimezoneForSession || hasNoTimezoneCookie) {
				// muss über sessionStorage gehen, da Chrome/Firefox Session Cookies nicht löschen
				try {
					const currentTimezone = _this.getTimezoneForModernBrowsers();
					_this.writeTimezoneToCookie(currentTimezone);
				} catch {
					/* old Browsers without Intl Interface fail - we don't care */
				}
			}
		},

		getTimezoneForModernBrowsers: function () {
			const invalidTimeZoneObject = typeof Intl.DateTimeFormat().resolvedOptions().timeZone !== 'string';
			if (invalidTimeZoneObject) {
				throw new Error('Timezone could not be resolved by Intl.DateTimeFormat');
			}
			return Intl.DateTimeFormat().resolvedOptions().timeZone; //z.B. "Europe/Berlin"
		},

		writeTimezoneToCookie: function (currentTimezone) {
			jPar.util.setCookie('timezone', currentTimezone);
			jPar.app.appState.set('sessionStorage', 'webapp', 'hasFreshTimezoneForSession', true);
		},
	},
});
